<output class="ev-loader" aria-live="polite">
  <div class="ev-loader__spinner" aria-hidden="true">
    <div class="ev-loader__spinner-track"></div>
    <div class="ev-loader__spinner-arc ev-loader__spinner-arc--outer"></div>
    <div class="ev-loader__spinner-arc ev-loader__spinner-arc--inner"></div>
    <svg class="ev-loader__bolt" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13 2 L4 14 H11 L9 22 L20 9 H13 Z" />
    </svg>
  </div>
  <div class="ev-loader__label">{{ label }}</div>
</output>
